// extracted by mini-css-extract-plugin
module.exports = {"trigger":"TopBarMenu_trigger_3ImG3","moreicon":"TopBarMenu_moreicon_3h7hb","divided":"TopBarMenu_divided_MH2K-"};